export function scheduledStatus (publishDate, archiveDate) {

    if(!archiveDate && !publishDate) {
        return ''
    }

    function getDateInMilliseconds(date1: string, date2:string) {
        // if date is null, use secondary date and increment it to force it to
        // be after 1st date
        return  date1
        ? new Date(date1).getTime() 
        : new Date(date2).getTime() + 1000;
    }

    const archiveDateInMilliseconds = getDateInMilliseconds(archiveDate, publishDate)


    const publishDateInMilliSeconds = getDateInMilliseconds(publishDate, archiveDate)



    return <span className='schedule-status'>{
        archiveDateInMilliseconds > publishDateInMilliSeconds
            ? '(Scheduled)'
            : '(Archiving Scheduled)'
    }</span>
}


export function foundInScheduledStatus(publishDate: string | null, archiveDate: string | null) {
  const now = Date.now();

  const publish = publishDate ? new Date(publishDate).getTime() : null;
  const archive = archiveDate ? new Date(archiveDate).getTime() : null;

  let status = '';

 
  if (archive && archive > now) {
    status = '(Archiving Scheduled)';
  } else if (archive && archive <= now && (!publish || archive > publish)) {
    status = '(Archived)';
  } else if (publish && publish > now) {
    status = '(Scheduled Publish)';
  } 

  return <span className="schedule-status">{status}</span>;
}
